import React from "react";
import styles from "./start-page.module.css";
import { Page } from "../../components/page/page";
import { YourGender } from "../../components/gender/gender";

const StartPage = () => {
  return (
    <Page title="Love Tarot" hideContinueButton={true}>
      <div className={styles.container_page}>
        <p className={styles.subtitle}>
          Discover feelings, blocks, and soulmate timing.
        </p>
        <div>
          <p className={styles.gender_text}>
            For an accurate reading, tell the cards about yourself
          </p>
          <YourGender />
        </div>
      </div>
    </Page>
  );
};

export { StartPage };
